import React from 'react';

const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || 'https://parkmesaj.com';
import { ExternalLink, ScanLine } from 'lucide-react';

// index.tsx'ten ayrıştırıldı — landing "DemoSection" bölümü
export default function DemoSection({ L, demoToken }: any) {
  return (
    <>
        <section id="demo" className="py-16 md:py-24 relative">
          <div className="divider-glow mb-0 mx-12" />

          {/* Background blob */}
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background: 'radial-gradient(ellipse 60% 40% at 50% 50%, rgba(245, 147, 0,0.15) 0%, transparent 70%)',
            }}
          />

          <div className="max-w-4xl mx-auto px-6 pt-20 relative z-10">
            <div className="glass-panel gradient-border rounded-3xl p-12 md:p-16 text-center">
              {/* Live indicator */}
              <div className="inline-flex items-center gap-2 glass-panel px-4 py-2 rounded-full text-xs text-[#34C3A0] uppercase tracking-widest font-semibold mb-8 border border-[rgba(52, 195, 160,0.2)]">
                <span className="w-2 h-2 rounded-full bg-[#34C3A0] animate-pulse" />
                {L.demo.badge}
              </div>

              <h2
                className="reveal text-4xl md:text-5xl font-black text-white mb-4"
                style={{ fontFamily: 'var(--font-heading)' }}
              >
                {L.demo.titlePrefix} <span className="gradient-text">{L.demo.titleHighlight}</span>
              </h2>
              <p className="reveal reveal-delay-1 text-gray-400 text-lg mb-10 max-w-xl mx-auto">
                {L.demo.subtitle}
              </p>

              <div className="reveal reveal-delay-2 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12 items-center mt-12">
                {/* Left — gerçek ürün ekranı (telefon çerçevesinde) */}
                <div className="flex justify-center order-2 md:order-1">
                  <div className="relative">
                    <div
                      className="absolute -inset-6 -z-10 blur-3xl opacity-50"
                      style={{ background: 'radial-gradient(ellipse at center, rgba(255, 176, 32,0.25), rgba(245, 147, 0,0.15), transparent 70%)' }}
                    />
                    <div className="relative w-[225px] rounded-[2.4rem] border border-white/10 bg-[#0B0F19] p-2.5 shadow-[0_30px_70px_rgba(0,0,0,0.6)]">
                      <div className="absolute left-1/2 -translate-x-1/2 top-3 w-20 h-4 bg-black rounded-full z-10" />
                      {/* eslint-disable-next-line @next/next/no-img-element */}
                      <img
                        src="/demo-alert.png"
                        alt={L.demo.phoneAlt}
                        className="w-full rounded-[1.9rem] block select-none"
                        draggable={false}
                      />
                    </div>
                  </div>
                </div>

                {/* Right — QR kodu + CTA */}
                <div className="order-1 md:order-2 flex flex-col items-center md:items-start gap-5 text-center md:text-left">
                  <div className="inline-flex items-center gap-2 text-xs text-[#FFB020] uppercase tracking-widest font-semibold">
                    <ScanLine size={15} /> {L.demo.scanHint}
                  </div>
                  <div className="neon-glow-cyan rounded-2xl p-4 bg-white inline-block">
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img
                      src={`/api/demo-qr?token=${encodeURIComponent(demoToken)}`}
                      alt={L.demo.demoQrAlt}
                      width={180}
                      height={180}
                      className="block"
                    />
                  </div>
                  <p className="text-xs text-gray-500">
                    <span className="font-mono text-[#FFB020]">parkmesaj.com/w/{demoToken}</span>
                    &nbsp;{L.demo.qrNote}
                  </p>
                  <a
                    href={`${SITE_URL}/w/${demoToken}`}
                    id="demo-try-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-shimmer text-white font-bold px-8 py-3.5 rounded-2xl text-base shadow-xl inline-flex items-center gap-2"
                  >
                    <ExternalLink size={18} /> {L.demo.openLink}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
    </>
  );
}
